import { UniqueHtmlElement } from './unique-html-element';

export class TemplateInputHandler extends UniqueHtmlElement<HTMLInputElement> {
  constructor(selector: string) {
    super(selector);
  }

  observe() {
    this.element?.addEventListener('input', e =>
      this.handleInputEvent(e as InputEvent),
    );
  }

  private handleInputEvent(e: InputEvent) {
    if (!this.isValid() && this.element?.value) {
      this.element.value = this.element.value.replace(e.data ?? '', '');
    }
  }

  private isValid() {
    const validator = new RegExp(
      /^[A-z0-9@!\'#".,\-%&\/\\()=?`^<>*{}|~\s]{0,10}$/g,
    );
    const isValid = validator.test(this.element?.value ?? '');

    return isValid;
  }
}
